module.exports = __webpack_public_path__ + "350014bbce63c9e5fa21b407e9b404e0.MP3";